<template>
  <v-menu offset-y min-width="150" ccontent-class="elevation-1">
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        rounded
        depressed
        color="white"
        class="add_assignment_item_button"
        v-bind="attrs"
        v-on="on"
        @click="handleAssignmentMenuClick"
      >
        {{ $t("academy_navigator.new") }}
      </v-btn>
    </template>
    <v-list class="pa-0">
      <v-list-item
        v-for="assignmentNewContextMenuItem in assignmentNewContextMenuItems"
        :key="assignmentNewContextMenuItem.name"
        @click="
          limitedFunctionality
            ? showLimitedFunctionality()
            : assignmentNewContextMenuItem.handleClick()
        "
        class="add-new-menu__item"
      >
        <span class="add-new-menu__item-text"
          >{{ assignmentNewContextMenuItem.name
          }}<v-icon color="secondary" size="20" class="ml-2">{{
            assignmentNewContextMenuItem.icon
          }}</v-icon></span
        >
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { i18n } from "@/plugins/i18n";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { mapGetters, mapMutations } from "vuex";
import { StorageItemTypes } from "../enums/StorageItemTypes";
import GetterTypes from "@/store/GetterTypes";
import { bus } from "@/main";

export default {
  name: "AddAssignmentItemMenu",
  data: instance => ({
    assignmentNewContextMenuItems: [
      {
        name: i18n.tc("assignments.todo_assignment"),
        icon: "mdi-check",
        handleClick: () => {
          return instance.toggleCreateAssignmentDialog({
            isCreateAssignmentDialogOpened: true,
            createAssignmentDialogType: StorageItemTypes.TODO
          });
        }
      },
      {
        name: i18n.tc("assignments.form_assignment"),
        icon: "mdi-file-document-outline",
        handleClick: () => {
          return instance.toggleCreateAssignmentDialog({
            isCreateAssignmentDialogOpened: true,
            createAssignmentDialogType: StorageItemTypes.FORM
          });
        }
      }
    ]
  }),

  computed: {
    ...mapGetters(ModuleTypes.ROOT, ["isRightSidebarOpened"]),
    ...mapGetters({
      limitedFunctionality: GetterTypes.GET_ORG_HAS_LIMITED_FUNCTIONALITY
    })
  },

  methods: {
    ...mapMutations(ModuleTypes.STORAGE, ["toggleCreateAssignmentDialog"]),
    ...mapMutations(ModuleTypes.ROOT, ["closeRightSidebar"]),

    handleAssignmentMenuClick() {
      if (this.isRightSidebarOpened) {
        this.closeRightSidebar();
      }
    },
    showLimitedFunctionality() {
      bus.$emit("showExpiredSubscription");
    }
  }
};
</script>

<style scoped>
.add_assignment_item_button {
  text-transform: capitalize;
}

.add-new-menu__item-text {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.v-menu__content {
  margin-top: 2px;
  border-radius: 10px;
}
</style>
